// This is an exact copy of packages/payment-integration-api/src/config/capabilities.ts
// Duplication is needed for interface export
// Please update both files if you want to make changes to the Capabilities interface

export enum B2BPaymentMethodFilterType {
    Standard = 'STANDARD',
    Invoice = 'INVOICE',
}

export interface Capabilities {
    userJourney: {
        disableEditCart: boolean;
        disableStoreCredit: boolean;
        hasCompanyAddressBook: boolean;
        hasAddressExtraFields: boolean;
        hasOrderExtraFields: boolean;
        requiresB2BToken: boolean;
    };
    customer: {
        superAdminCompanySelector: boolean;
    };
    shipping: {
        restrictManualAddressEntry: boolean;
        prefillCompanyAddress: boolean;
        hideSaveToAddressBookCheck: boolean;
        hideBillingSameAsShippingCheck: boolean;
    };
    billing: {
        restrictManualAddressEntry: boolean;
        hideSaveToAddressBookCheck: boolean;
    };
    payment: {
        paymentMethodFiltering: boolean;
        b2bPaymentMethodFilterType: B2BPaymentMethodFilterType | null;
        poPaymentMethod: boolean;
        poConfig: {
            label: string;
            required: boolean;
            creditLimit: number;
            currency: string;
        } | null;
        additionalPaymentNotes: boolean;
        additionalField: {
            label: string;
            required: boolean;
        } | null;
        excludeOfflineForInvoice: boolean;
        excludePPSDK: boolean;
    };
    orderConfirmation: {
        orderSummary: boolean;
        persistB2BMetadata: boolean;
        storeQuoteId: boolean;
        storeInvoiceReference: boolean;
        invoiceRedirect: boolean;
    };
}
